import { render } from "./EntityDataTable.vue?vue&type=template&id=d673ee02"
import script from "./EntityDataTable.vue?vue&type=script&lang=js"
export * from "./EntityDataTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__